import React from 'react';

export const FavoriteIcon: React.FC<{
  onClick: () => void;
  isFavorite: boolean;
}> = ({ onClick, isFavorite }) => {
  const imgSrc = isFavorite ? '/favorite.svg' : '/not_favorite.svg';
  return (
    <div onClick={onClick} style={{ cursor: 'pointer' }}>
      <img src={imgSrc} alt='Heart Icon' />
    </div>
  );
};
